<template>
	<div id="app" :class="{ 'mobile-view': isMobile }" >
		<div class="header">
			<div class="header-content">
				<div class="header-logos-text">
					<div class="logo-container">
						<WFBuildingLogo />
					</div>
					<div class="header-text hide-on-mobile">
					</div>
				</div>
				
				<div v-if="mapIsLoaded">
					
					<div v-if="isMobile" class="language-container">
						<CustomLanguageDropdown />
					</div>
					
					
					<div v-if="!isMobile && !isPortrait" class="language-container desktop-language">
						<CustomLanguageDropdown />
					</div>
				</div>
				
			
				<div v-if="!isMobile && settingsData.showClock" class="clock-container">
					<div class="clock-time">{{ currentTime }}</div>
					<div v-if="settingsData.showDate" class="clock-date">{{ currentDate }}</div>
				</div>
			</div>
		</div>
		<div class="map-and-menus">
			<div class="map-area-container" :class="{'map-search-visible': searchVisible}">
				<WFMap @poiClicked="onMapPOIClick" @onTouch="onClick" @loaded="mapLoaded" ref="map" :api="apiHost" :assets="assetHost" project="a69b782522d22b3f24e706f0b726f015"/>
				<Search @clicked="onSearchPOIClick" @close="onSearchClose"/>
			</div>
			<transition name="shortcuts-menu">
				<div v-show="shortcutsHidden" class="shortcuts-overlay">
					<div class="shortcuts-backdrop" @click="shortcutsHidden = false"></div>
					<div class="shortcuts-modal">
						<div class="shortcuts-header">
							<span class="shortcuts-title" data-translation-element="shortcuts-title">KIIRVALIKUD</span>
							<button class="shortcuts-close" @click="shortcutsHidden = false">&times;</button>
						</div>
						<ShortcutsMenu v-on:changeValue="handleChangeValue()"/> 
					</div>
				</div>
			</transition> 
			<div class="menus">
				<div class="menus-bottom">
					<div class="search-bar">
					
						<div @click="onShortcutsButtonClick()" class="shortcuts-button" role="button">
							<img src="./assets/person.svg" alt="Shortcuts">
							<span class="shortcuts-label" data-translation-element="facilities-label">FACILITIES</span>
						</div>
						<TabButtons @switchTab="switchMainTab" />
						
						
						<div v-if="mapIsLoaded && !isMobile && isPortrait" class="languages-container portrait-languages">
							<div class="wf-languages-container">
								<ul class="wf-list">
									<li 
										v-for="lang in availableLanguages" 
										:key="lang.code"
										@click="changeLanguage(lang.code)"
										class="language"
										:class="{ active: currentLanguage === lang.code }"
									>
										<div class="wf-flag" :style="{ backgroundImage: `url(${lang.flagUrl})` }"></div>
									</li>
								</ul>
							</div>
						</div>
						
						<WFFloorsMenu :currentFloor="currentFloor" :hideWhenSingleFloor="true"/> 
					</div>
					<div class="col col-tabs-container tabs-container">
						<WFTabs ref="tabs" :activeTab="currentTab" animate="horizontal">
							<WFTab name="groups">
								<WFScrollableArea>
									<GroupsMenu @poiClicked="onPOIClick" @clicked="onGroupMenuClick" :showPOIs="false" :show-icon="true"/>
								</WFScrollableArea>
							</WFTab>
							<WFTab name="group-pois">
								<WFScrollableArea>
									
									<div class="list-back-header" @click="toGroups">
										<img src="./assets/back-arrow.png" class="back-arrow-icon">
										<span data-translation-element="back-button">TAGASI</span>
									</div>
									<GroupPOIsMenu v-show="currentGroup" :group="currentGroup" @clicked="onPOIClick"/>
								</WFScrollableArea>
							</WFTab>
							<WFTab name="poi-info">
								<div class="scrollable">
									<div class="poi-portrait">
										<div @click="toGroupPOIs()" class="back-button">
											<img src="./assets/back-arrow.png">	
										</div>
										<POI :poi="currentPOI" :showLogo="true" :showPathButton="true" :showDescription="true"/>
									</div>
								</div>
							</WFTab>
						</WFTabs>
					</div>
				</div>
			</div>
		</div>
		<div id="screensaver" class="banners-screensaver" v-show="screensaver" @click="hideBanner()">
			<Screensaver />
		</div>
	</div>
</template>

<script>

import { WFMap, WFFloorsMenu, WFTabs, WFTab, WFAZMenu, WFScrollableArea, WFBanner, WFBuildingLogo, WFYAH, WFFlagsMenu} from '@3dwayfinder/wayfinder-vue-components'

import CustomLanguageDropdown from './components/CustomLanguageDropdown.vue'
import TabButtons from './components/TabButtons.vue'
import Search from './components/Search.vue'
import ShortcutsMenu from './components/ShortcutsMenu.vue'
import GroupsMenu from './components/GroupsMenu.vue'
import GroupPOIsMenu from './components/GroupPOIsMenu.vue'
import POI from './components/POI.vue'
import { mapState } from 'vuex';
import Screensaver from './components/Screensaver.vue'

export default {
	name: 'app',
	components: {
		WFMap,
		WFFloorsMenu,
		WFAZMenu,
		GroupsMenu,
		WFFlagsMenu,
		WFBuildingLogo,
		WFYAH,
		CustomLanguageDropdown,
		TabButtons,
		POI,
		WFTabs,
		WFTab,
		Search,
		ShortcutsMenu,
		WFBanner,
		WFScrollableArea,
		GroupPOIsMenu,
		Screensaver
	},
	data () {
		return {
			lastClick: false,
			landscape: false,
			screensaver: false,
			hasScreensaver: false,
			isHighlighted: false,
			shortcutsHidden: false,
			currentTab: "groups",
			currentGroup: null,
			mapIsLoaded: false,
			isPortrait: window.matchMedia("(orientation: portrait)").matches,
			
			
			currentTime: '',
			currentDate: '',
			clockInterval: null,
			
			// Kella setting ja värvi mockdata
			settingsData: {
				showClock: true,  
				showDate: true,   
				colors: {
					primary: '#BEAA74',           
					'primary-content': '#FFFFFF', 
					secondary: '#333333',        
					'secondary-content': '#FFFFFF',
					accent: '#f5f5f5',            
					'accent-content': '#333333',
					'base-100': '#FFFFFF',        
					'base-200': '#f4f4f4',       
					'base-content': '#333333',    
				}
			}
		}
	},
	computed: {
		...mapState('wf', ['maxInActivity', 'currentFloor']),
		...mapState(['currentPOI', 'searchVisible']),
		apiHost () {
			console.log('apiHost', this.$WF_API_HOST);
			return this.$WF_API_HOST;
		},
		assetHost () {
			return this.$WF_ASSET_HOST;
		},
		isMobile() {
			return window.innerWidth <= 480;
		},
		currentLanguage() {
			return this.$store.state.wf.language || 'et';
		},
		isLocalhost() {
			return window.location.hostname === 'localhost' || 
			       window.location.hostname === '127.0.0.1' ||
			       window.location.hostname.startsWith('192.168');
		},
		settings() {
			return this.settingsData;
		},
		availableLanguages() {
			
			const wfLanguages = this.$store.state.wf.languages || [];
			
			const flagMap = {
				'et': 'https://flagcdn.com/w80/ee.png',
				'en': 'https://flagcdn.com/w80/gb.png',
				'fi': 'https://flagcdn.com/w80/fi.png',
				'lv': 'https://flagcdn.com/w80/lv.png',
				'ru': 'https://flagcdn.com/w80/ru.png',
				'sv': 'https://flagcdn.com/w80/se.png',
				'no': 'https://flagcdn.com/w80/no.png',
				'da': 'https://flagcdn.com/w80/dk.png',
				'de': 'https://flagcdn.com/w80/de.png',
				'fr': 'https://flagcdn.com/w80/fr.png',
			};
			
			
			const preferredOrder = ['et', 'en', 'fi', 'ru', 'lv'];
			
			const mapped = wfLanguages.map(lang => {
				const code = lang.code || (lang.name && lang.name.toLowerCase()) || '';
				return {
					code: code,
					name: lang.name || code.toUpperCase(),
					flagUrl: flagMap[code] || 'https://flagcdn.com/w80/' + code + '.png'
				};
			});
			
			
			return mapped.sort((a, b) => {
				const indexA = preferredOrder.indexOf(a.code);
				const indexB = preferredOrder.indexOf(b.code);
				
				if (indexA !== -1 && indexB !== -1) {
					return indexA - indexB;
				}
				if (indexA !== -1) return -1;
				if (indexB !== -1) return 1;
				return 0;
			});
		}
	},
	watch: {
		'settingsData.colors': {
			handler() {
				this.applyColorSettings();
			},
			deep: true
		},
		
		'$store.state.wf.language': {
			handler() {
				this.updateClock();
			}
		}
	},
	mounted() {
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('orientationchange', this.handleResize);
		this.handleResize(); 
		
		
		this.loadSettings();
		this.applyColorSettings();
		
		
		this.updateClock();
		this.clockInterval = setInterval(this.updateClock, 1000);
		
		
		this.fixSearchBarWidth();
		window.addEventListener('resize', this.fixSearchBarWidth);
		
		
		setTimeout(() => {
			this.addMockFloors();
		}, 2000);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleResize);
		window.removeEventListener('orientationchange', this.handleResize);
		window.removeEventListener('resize', this.fixSearchBarWidth);
		if (this.clockInterval) {
			clearInterval(this.clockInterval);
		}
	},
	methods: {
		
		fixSearchBarWidth() {
			if (window.innerWidth >= 1281) {
				this.$nextTick(() => {
					const searchBar = document.querySelector('.search-bar');
					const tabButtons = document.querySelector('.search-bar .tab-buttons');
					const shortcutsBtn = document.querySelector('.search-bar .shortcuts-button');
					
					if (searchBar && tabButtons && shortcutsBtn) {
						const searchBarWidth = searchBar.offsetWidth;
						const shortcutsBtnWidth = shortcutsBtn.offsetWidth;
						const margins = 24; 
						const newWidth = searchBarWidth - shortcutsBtnWidth - margins;
						
						tabButtons.style.width = newWidth + 'px';
						tabButtons.style.maxWidth = newWidth + 'px';
						tabButtons.style.flexGrow = '0';
						tabButtons.style.flexShrink = '0';
					}
				});
			}
		},
		
		loadSettings() {
			if (this.isLocalhost) {
				console.log('📋 Using localhost mock settings');
				console.log('🎨 Mock colors:', this.settingsData.colors);
				return;
			}
			
			// PRODUCTION: Load from Wayfinder CMS
			try {
				const wf = this.$wayfinder || window.wayfinder;
				
				if (!wf) {
					console.warn('Wayfinder instance not found, using default settings');
					return;
				}
				
				if (!wf.settings) {
					console.warn('Wayfinder settings not available, using default settings');
					return;
				}
				
				console.log('📋 Loading settings from Wayfinder CMS');
				
				// Load clock/date visibility settings
				this.settingsData.showClock = wf.settings['template.default.display-clock'] !== false;
				this.settingsData.showDate = wf.settings['template.default.display-date'] !== false;
				
				// Update colors from CMS
				this.settingsData.colors = {
					primary: wf.settings['template.color.primary'] || '#BEAA74',
					'primary-content': wf.settings['template.color.primary-content'] || '#FFFFFF',
					secondary: wf.settings['template.color.secondary'] || '#333333',
					'secondary-content': wf.settings['template.color.secondary-content'] || '#FFFFFF',
					accent: wf.settings['template.color.accent'] || '#f5f5f5',
					'accent-content': wf.settings['template.color.accent-content'] || '#333333',
					'base-100': wf.settings['template.color.base-100'] || '#FFFFFF',
					'base-200': wf.settings['template.color.base-200'] || '#f4f4f4',
					'base-content': wf.settings['template.color.base-content'] || '#333333',
				};
				
				console.log('🎨 Colors loaded from CMS:', this.settingsData.colors);
				
			} catch (error) {
				console.error('Error loading Wayfinder settings:', error);
				console.warn('Using default settings');
			}
		},
		
		// Update clock and date
		updateClock() {
			const now = new Date();
			
			
			let lang = 'et';
			if (this.$store && this.$store.state && this.$store.state.wf && this.$store.state.wf.language) {
				lang = this.$store.state.wf.language;
			}
			
			
			const localeMap = {
				'et': 'et-EE',
				'en': 'en-GB',
				'ru': 'ru-RU',
				'fi': 'fi-FI',
				'lv': 'lv-LV',
				'sv': 'sv-SE',
				'no': 'nb-NO',
				'da': 'da-DK',
				'de': 'de-DE',
				'fr': 'fr-FR'
			};
			
			const locale = localeMap[lang] || 'et-EE';
			
			
			this.currentTime = now.toLocaleTimeString(locale, {
				hour: '2-digit',
				minute: '2-digit',
				hour12: false
			});
			
			
			this.currentDate = now.toLocaleDateString(locale, {
				day: 'numeric',
				month: 'long',
				year: 'numeric'
			});
		},
		
		
		applyColorSettings() {
			const colors = this.settingsData.colors;
			const root = document.documentElement;
			
			Object.keys(colors).forEach(colorKey => {
				root.style.setProperty(`--color-${colorKey}`, colors[colorKey]);
			});
			
			
			const primaryColor = colors.primary || '#da020e';
			root.style.setProperty('--color-primary-glow', `${primaryColor}66`); // 40% opacity
			
			console.log('🎨 Colors applied to CSS variables');
		},
		
		handleResize() {
			this.isPortrait = window.matchMedia("(orientation: portrait)").matches;
		},
		
		
		addMockFloors() {
			const floorsList = document.querySelector('.wf-floors-menu .wf-list');
			if (floorsList) {
				
				const existingItems = Array.from(floorsList.querySelectorAll('.wf-list-item'));
		
				floorsList.innerHTML = '';
				
				const allFloors = [2, 1];
				
				allFloors.forEach(floorNum => {
					
					const existingFloor = existingItems.find(item => {
						const title = item.querySelector('.wf-title');
						return title && title.textContent.trim() === String(floorNum);
					});
					
					if (existingFloor) {
				
						floorsList.appendChild(existingFloor);
						
						existingFloor.addEventListener('click', () => {
							floorsList.querySelectorAll('[data-mock-floor]').forEach(mockItem => {
								mockItem.classList.remove('wf-active');
							});
						});
					} else {
					
						const li = document.createElement('li');
						li.className = 'wf-list-item';
						li.setAttribute('data-mock-floor', floorNum);
						li.innerHTML = `<span class="wf-title">${floorNum}</span>`;
						li.addEventListener('click', () => {
							
							floorsList.querySelectorAll('.wf-list-item').forEach(item => {
								item.classList.remove('wf-active');
							});
						
							li.classList.add('wf-active');
							console.log(`Mock floor ${floorNum} clicked`);
						});
						floorsList.appendChild(li);
					}
				});
				
				console.log('Mock floors added for testing - order: 5,4,3,2,1 (top to bottom)');
			}
		},

		changeLanguage(langCode) {
			if (this.$wayfinder && this.$wayfinder.setLanguage) {
				this.$wayfinder.setLanguage(langCode);
			}
		},
		onClick () {
			clearTimeout(this.lastClick);
			this.$refs['map'].run();
			
			this.lastClick = setTimeout(() => {
				if(this.$refs.map) {
					this.$refs.map.reset();
				}
				this.reset();
			}, this.maxInActivity * 1000);
			return false;
		},
		handleChangeValue() {
			this.shortcutsHidden = false;
		},
		changeTab (tab) {
			this.currentTab = tab;			
		},
		onBackClick() {
			this.changeTab('groups');
			this.$wayfinder.clearPath();
			this.$wayfinder.clearHighlights();
			this.isHighlighted = false;
			this.handleChangeValue();
		},
		getPOIs() {
			if (this.currentGroup.pois) {
				let arr = this.currentGroup.pois.slice(0);
				return arr.sort((a, b) => {
					return a.getName(this.language).localeCompare(b.getName(this.language));
				});
			}
			else {
				return [];
			}
		},
		onGroupMenuClick (group) {
			if(group == this.currentGroup) {
				if (this.isHighlighted = true) {
					this.$wayfinder.setHighlights(group.getPOIs());
					this.isHighlighted = true;
					this.changeTab('group-pois');
					console.log("vajutatud 1")

				} else {
					console.log(this.isHighlighted);
					this.$wayfinder.clearHighlights();
					this.isHighlighted = false;
					console.log("vajutatud 2")
					this.changeTab('group-pois');
				}
			} else {
				this.isHighlighted = true;
				this.$wayfinder.clearHighlights();
				this.$wayfinder.setHighlights(group.getPOIs());
				this.currentGroup =  Object.freeze(group);
				this.changeTab('group-pois');
				console.log("vajutatud")
			}
		},
		onMapPOIClick (poi) {
			this.$store.dispatch('setPOI', poi);
			this.changeTab('poi-info');

			if (this.portrait) {
				this.changeTab('poi-info');
			}
		},
		onPOIClick (poi) {
			console.log('onPOIClick', poi, this.landscape);
			this.$store.dispatch('setPOI', poi);
			this.$wayfinder.clearHighlights();
			this.$wayfinder.setHighlights([poi]);
			this.changeTab('poi-info');

			this.$wayfinder.statistics.onClick(poi.id, "menu");
		},
		onSearchPOIClick (poi) {
			if (poi) {
				this.onPOIClick(poi);
				this.$wayfinder.showPath(poi.getNode(), poi)
				this.$wayfinder.clearHighlights();
				this.$wayfinder.setHighlights([poi]);
			}
		},
		onSearchClose () {
			if (this.landscape) {
				//this.$store.dispatch('SET_CURRENT_TAB', 'poi-info');
			}
		},
		reset () {
			this.changeTab('groups');
			this.$store.dispatch('SHOW_SEARCH', false);
			this.$store.dispatch('wf/SET_RESET');
			this.screensaver = this.hasScreensaver;
			this.$refs['map'].pause();
		},
		doSomething () {},
		switchMainTab (tab) {
			if (tab !== 'search') {
				this.changeTab(tab);
			}
			else {
				this.$store.dispatch('SHOW_SEARCH', !this.searchVisible);
			}
		},
		onBannerClick (/*frame, container*/) {
			this.screensaver = false;
			this.$refs['map'].run();
		},
		onShortcutsButtonClick() {
			this.shortcutsHidden = !this.shortcutsHidden;
		},
		
		toGroups () {
			this.changeTab('groups');
			this.$wayfinder.clearHighlights();
			this.isHighlighted = false;
		},
		toGroupPOIs () {
			
			if (this.currentGroup) {
				this.changeTab('group-pois');
			} else {
				this.toGroups();
			}
		},
		hideBanner () {
			this.screensaver = false;
		},
		mapLoaded () {
			this.$refs['map'].run();
			this.mapIsLoaded = true;
			
			
			this.loadSettings();
			this.applyColorSettings();
		},
		hasBanners (has) {
			this.hasScreensaver = has;
		}
	}
};
</script>

<style lang="less">
	@import 'theme/styles';
	@import 'theme/responsive';
	@font-face {
		font-family: "PF Square Sans Pro Medium";
		src: local("PF Square Sans Pro"),
		url(./fonts/PFSquareSansProMedium_35487.ttf) format("truetype");
	}

	@font-face {
		font-family: "PF Centro Sans Pro Bold";
		src: local("PF Centro Sans Pro"),
		url(./fonts/PFCentroSansPro-Bold-subset.otf) format("opentype");
	}
	@font-face {
		font-family: "PF Centro Sans Pro Regular";
		src: local("PF Centro Sans Pro"),
		url(./fonts/PFCentroSansPro-Reg-subset.otf) format("opentype");
	}

	
	.shortcuts-menu-enter-active,
	.shortcuts-menu-leave-active {
		transition: all 0.3s ease;
	}

	.shortcuts-menu-enter,
	.shortcuts-menu-leave-to {
		opacity: 0;
		transform: translateY(-20px);
	}

	/* Arrow animation for quick button */
	.arrow-icon {
		transition: transform 0.3s ease;
	}

	.arrow-icon.arrow-open {
		transform: rotate(90deg);
	}
	
	
	.clock-container {
		display: flex;
		flex-direction: column;
		align-items: flex-end;
		justify-content: center;
		padding-right: 2rem;
		color: var(--color-primary-content, #FFFFFF);
		margin-bottom: 2rem;
	}
	
	.clock-time {
		font-size: 2rem;
		font-weight: 700;
		line-height: 1.2;
	}
	
	.clock-date {
		font-size: 1rem;
		font-weight: 400;
		opacity: 0.9;
	}
	
	@media (min-width: 481px) and (max-width: 1280px) and (orientation: portrait) {
		.clock-container {
			padding-right: 1.5rem;
		}
		
		.clock-time {
			font-size: 1.8rem;
		}
		
		.clock-date {
			font-size: 1.2rem;
		}
	}
	
	/* Landscape mode adjustments */
	@media (min-width: 1281px) {
		.clock-container {
			padding-right: 2.5rem;
			margin-right: 2rem;
		}
		
		.clock-time {
			font-size: 2.2rem;
		}
		
		.clock-date {
			font-size: 1.1rem;
		}
		
		
		.desktop-language {
			position: absolute;
			right: 100px; /* Position to the left of clock */
			top: 50%;
			transform: translateY(-60%);
		}
		
		.header-content {
			position: relative;
		}
	}
	
	/* Fix search bar in landscape - must be outside media query for higher specificity */
	@media (min-width: 1281px) {
		.menus .menus-bottom .search-bar {
			justify-content: flex-start !important;
		}
		
		.menus .menus-bottom .search-bar .tab-buttons {
			flex: 1 1 auto !important;
			flex-grow: 1 !important;
		}
	}
	
	/* Also target general landscape orientation */
	@media (orientation: landscape) and (min-width: 1024px) {
		#app .menus .menus-bottom .search-bar {
			justify-content: flex-start !important;
		}
		
		#app .menus .menus-bottom .search-bar .tab-buttons {
			flex: 1 1 auto !important;
			flex-grow: 1 !important;
		}
	}
	
	/* =====================================================
	   DYNAMIC COLOR OVERRIDES - Using CSS Variables
	   ===================================================== */
	
	/* Header - uses primary color (ALL VIEWS: mobile, portrait, landscape) */
	.header,
	#app .header,
	.mobile-view .header,
	#app.mobile-view .header {
		background-color: var(--color-primary, #da020e) !important;
		color: var(--color-primary-content, #FFFFFF) !important;
	}
	
	.header-content,
	#app .header-content {
		color: var(--color-primary-content, #FFFFFF) !important;
		background-color: var(--color-primary, #da020e) !important;
	}
	
	.header-text label,
	.rimi-container label {
		color: var(--color-primary-content, #FFFFFF) !important;
	}
	
	/* Floor buttons - use primary color for active state (ALL VIEWS) */
	.wf-floors-menu .wf-list-item,
	.wf-floors-menu .wf-list .wf-list-item,
	.wf-floors-menu ul li {
		background-color: var(--color-base-100, #FFFFFF) !important;
		color: var(--color-base-content, #333333) !important;
		border: 1px solid #e0e0e0 !important;
		box-shadow: none !important;
	}
	
	.wf-floors-menu .wf-list-item.wf-active,
	.wf-floors-menu .wf-list .wf-list-item.wf-active,
	.wf-floors-menu ul li.wf-active {
		background-color: var(--color-primary, #da020e) !important;
		color: var(--color-primary-content, #FFFFFF) !important;
		border-color: var(--color-primary, #da020e) !important;
		box-shadow: 0 4px 15px var(--color-primary-glow, rgba(218, 2, 14, 0.4)) !important;
	}
	
	.wf-floors-menu .wf-list-item:hover:not(.wf-active) {
		background-color: var(--color-base-200, #f4f4f4) !important;
	}
	
	/* Menu/sidebar background - uses accent color */
	.menus {
		background-color: var(--color-accent, #f5f5f5) !important;
	}
	
	.menus-bottom {
		background-color: var(--color-accent, #f5f5f5) !important;
	}
	
	.tabs-container {
		background-color: var(--color-base-100, #FFFFFF) !important;
	}
	
	/* Search bar area */
	.search-bar {
		background-color: var(--color-accent, #f5f5f5) !important;
	}
	
	/* Groups menu items */
	.wf-groups-menu .wf-list-item {
		color: var(--color-base-content, #333333) !important;
	}
	
	/* POI list items */
	.wf-poi-list .wf-list-item,
	.wf-poi-list-item {
		color: var(--color-base-content, #333333) !important;
		background-color: var(--color-base-100, #FFFFFF) !important;
	}
	
	/* TAGASI back header - FIXED COLOR (not dynamic) 
	   Using a nice accent green/teal that works well */
	.list-back-header {
		 /* Fixed green color */
		color: #FFFFFF !important;
	
	}
	
	/* Show path button - uses primary color */
	.show-path-button,
	.wf-show-path-button {
		background-color: var(--color-primary, #da020e) !important;
		color: var(--color-primary-content, #FFFFFF) !important;
	}
	
	/* Shortcuts/Quick access modal header - uses primary color */
	.shortcuts-header,
	.shortcuts-modal .shortcuts-header,
	.shortcuts-overlay .shortcuts-header,
	#app .shortcuts-header,
	#app .shortcuts-overlay .shortcuts-modal .shortcuts-header,
	div.shortcuts-header {
		background-color: var(--color-primary, #da020e) !important;
		background: var(--color-primary, #da020e) !important;
		color: var(--color-primary-content, #FFFFFF) !important;
	}
	
	.shortcuts-header .shortcuts-title,
	.shortcuts-title,
	#app .shortcuts-title {
		color: var(--color-primary-content, #FFFFFF) !important;
	}
	
	.shortcuts-header .shortcuts-close,
	.shortcuts-close,
	#app .shortcuts-close {
		color: var(--color-primary-content, #FFFFFF) !important;
		background-color: transparent !important;
		background: transparent !important;
	}
	
	/* Map area background - uses base-100 color */
	.map-area-container,
	.wf-map,
	.wf-map-container,
	#app .map-area-container {
		background-color: var(--color-base-100, #FFFFFF) !important;
	}
	
	/* Canvas background - needs high specificity to override existing styles */
	.wf-map canvas,
	.wf-map-container canvas,
	#app .wf-map canvas,
	#app .wf-map-container canvas,
	.map-area-container .wf-map canvas,
	.map-area-container .wf-map-container canvas,
	canvas.wf-canvas,
	#app canvas {
		background-color: var(--color-base-100, #FFFFFF) !important;
		background: var(--color-base-100, #FFFFFF) !important;
	}
	
	/* Body/html background as fallback */
	html, body {
		background-color: var(--color-base-100, #FFFFFF) !important;
	}

	/* Mobile specific header fix */
	@media (max-width: 480px) {
		.header,
		#app .header,
		.mobile-view .header {
			background-color: var(--color-primary, #da020e) !important;
		}
		
		.header-content {
			background-color: var(--color-primary, #da020e) !important;
		}
	}
	
	/* Portrait specific header fix */
	@media (min-width: 481px) and (max-width: 1280px) and (orientation: portrait) {
		.header,
		#app .header {
			background-color: var(--color-primary, #da020e) !important;
		}
		
		.header-content {
			background-color: var(--color-primary, #da020e) !important;
		}
	}

	/* ============================================================
	   4K LANDSCAPE (3840x2160) - Bigger sidebar
	   ============================================================ */
	@media (min-width: 3000px) and (orientation: landscape) {
		html {
			font-size: 32px !important;
		}
		
		.menus {
			width: 700px !important;
			min-width: 700px !important;
			max-width: 700px !important;
		}
		
		.wf-component.wf-floors-menu {
			right: 720px !important;
		}
		
		.search-bar {
			height: 90px !important;
			
			.shortcuts-button {
				width: 70px !important;
				height: 70px !important;
			}
			
			.tab-buttons {
				height: 70px !important;
			}
		}
		
		.wf-groups-menu .wf-list-item {
			height: 80px !important;
			
			.wf-group .wf-name {
				font-size: 1.3rem !important;
				max-width: 280px !important;
			}
			
			.wf-group-icon {
				width: 38px !important;
				height: 38px !important;
			}
		}
		
		.wf-component.wf-floors-menu .wf-list-item {
			width: 5.5rem !important;
			height: 5.5rem !important;
			min-width: 5.5rem !important;
			min-height: 5.5rem !important;
			font-size: 2.2rem !important;
		}
	}

	/* ============================================================
	   4K PORTRAIT (2160x3840) - Full override - KIOSK SIZE
	   ============================================================ */
	@media (min-width: 1281px) and (orientation: portrait) {
		html {
			font-size: 48px !important;
		}
		
		/* Force portrait layout */
		.map-and-menus {
			flex-direction: column !important;
		}
		
		.map-area-container {
			flex: none !important;
			width: 100% !important;
			height: 52% !important;
			left: 0 !important;
		}
		
		.menus {
			width: 100% !important;
			min-width: 100% !important;
			max-width: 100% !important;
			height: 48% !important;
			flex: none !important;
			padding: 1.5rem !important;
			box-shadow: none !important;
		}
		
		/* ============================================================
		   HEADER - 4K Portrait - Copy of base styles, scaled for 4K
		   ============================================================ */
		.header {
			width: 100% !important;
			height: 6rem !important;
			display: flex !important;
			flex-direction: row !important;
			flex-wrap: nowrap !important;
			z-index: 1000 !important;
		}
		
		.header .language-container.desktop-language,
		.header .desktop-language {
			display: none !important;
		}
		
		.header .hide-on-mobile {
			display: flex !important;
		}
		
		.header .header-content {
			height: 100% !important;
			flex-grow: 1 !important;
			display: flex !important;
			flex-direction: row !important;
			justify-content: flex-start !important;
			align-items: center !important;
			padding: 0 !important;
		}
		
		.header .header-content .header-logos-text {
			display: flex !important;
			align-items: center !important;
			height: 100% !important;
			flex: 0 0 auto !important;
			gap: 1rem !important;
			margin-left: 1rem !important;
		}
		
		.header .logo-container {
			display: flex !important;
			align-items: center !important;
			width: 18rem !important;
			height: 100% !important;
			margin-left: 0 !important;
			flex-shrink: 0 !important;
		}
		
		.header .logo-container .wf-building-logo {
			height: 70% !important;
			width: 100% !important;
			margin: auto !important;
			background-size: contain !important;
			background-repeat: no-repeat !important;
			background-position: left center !important;
		}
		
		/* Override Vue scoped styles with higher specificity */
		.header .logo-container .wf-building-logo[data-v-38faefb4],
		.header .logo-container div.wf-building-logo,
		.header .logo-container .wf-component.wf-building-logo,
		div.header div.logo-container div.wf-building-logo {
			background-size: contain !important;
			background-repeat: no-repeat !important;
			background-position: left center !important;
			height: 70% !important;
			width: 100% !important;
		}
		
		.header .header-text {
			margin-left: 0 !important;
			display: flex !important;
			align-items: center !important;
			justify-content: start !important;
			flex-shrink: 0 !important;
			gap: 0.5rem !important;
		}

		.wf-poi-description {
			width: 90% !important;
			max-width: 100% !important;
			margin: 0 auto !important;
			padding: 1rem !important;
			font-size: 1.2rem !important;
			text-align: center !important;
			line-height: 1.4 !important;
		}

		.wf-poi-image {
			max-width: 20rem !important;
			margin-left: 10rem;
		}

		.back-button {
			padding: 1rem !important;
			margin: 1rem !important;
			cursor: pointer !important;
			
			img {
				width: 80px !important;
				height: 80px !important;
				min-width: 3rem !important;
				min-height: 3rem !important;
			}
		}

			.wf-poi-name {
			font-size: 1.5rem !important;
			text-align: left !important;
			margin-bottom: 1rem !important;
		}
		
		.wf-show-path,
		.show-path-button {
			position: relative !important;
			z-index: 0 !important;
			width: 100% !important;
			max-width: 100% !important;
		}

		.wf-show-path button,
		.wf-show-path .show-path-button {
			font-size: 2rem !important;
			height: 120px !important;
			min-height: 120px !important;
			padding-left: 3rem !important;
			padding-right: 3rem !important;
			width: 100% !important;
			max-width: 100% !important;
			border-radius: 16px !important;
			gap: 1rem !important;
			
			label {
				font-size: 2rem !important;
				font-weight: 700 !important;
			}
			
			.path-icon {
				width: 48px !important;
				height: 48px !important;
			}
		}

		.header .header-text label {
			font-size: 0.9rem !important;
			white-space: nowrap !important;
		}
		
		.header .header-text .line {
			margin-left: 0.5rem !important;
			font-size: 1rem !important;
		}
		
		.header .rimi-container {
			display: flex !important;
			align-items: center !important;
			flex-shrink: 0 !important;
			gap: 0.3rem !important;
		}
		
		.header .rimi-container img {
			width: 4rem !important;
			height: auto !important;
			padding: 0 !important;
		}
		
		.header .rimi-container label {
			font-size: 0.9rem !important;
			white-space: nowrap !important;
		}
		
		/* Clock - force smaller size with pixels */
		.header .clock-container,
		.header-content .clock-container,
		#app .header .clock-container,
		.clock-container {
			display: flex !important;
			flex-direction: column !important;
			align-items: flex-end !important;
			justify-content: center !important;
			margin-left: auto !important;
			margin-right: 30px !important;
			padding: 0 !important;
			padding-right: 0 !important;
			padding-top: 0 !important;
			padding-bottom: 0 !important;
			padding-left: 0 !important;
			flex-shrink: 0 !important;
			height: 100% !important;
			width: 200px !important;
			max-width: 200px !important;
			min-width: 150px !important;
		}
		
		.clock-time {
			font-size: 60px !important;
			font-weight: 700 !important;
			line-height: 1 !important;
			white-space: nowrap !important;
			margin-right: 2rem;
			margin-top: 2rem;
		}
		
		.clock-date {
			font-size: 40px !important;
			opacity: 0.9 !important;
			white-space: nowrap !important;
			margin-top: 4px !important;
			margin-right: 2rem;
		}
		
		/* Search bar - MUCH BIGGER */
		.search-bar {
			height: 250px !important;
			border: none !important;
			margin-bottom: 0 !important;
			background-color: #e3e3e3 !important;
			border-radius: 16px 16px 0 0 !important;
			display: flex !important;
			align-items: center !important;
			
			.shortcuts-button {
				width: 250px !important;
				height: 210px !important;
				flex-shrink: 0 !important;
				border-radius: 32px !important;
				
				img {
					width: 80px !important;
					height: 80px !important;
				}
				
				.shortcuts-label {
					font-size: 0.8rem !important;
					margin-top: 8px !important;
				}
			}
			
			.tab-buttons {
				flex: 1 !important;
				height: 220px !important;
				
				.tab-button {
					font-size: 1.2rem !important;
					border-radius: 32px !important;
				}
			}
			
			/* Language flags - MUCH BIGGER */
			.languages-container.portrait-languages {
				display: flex !important;
				flex-shrink: 0 !important;
				align-items: center !important;
				
				.wf-languages-container {
					width: auto !important;
					height: auto !important;
				}
				
				.wf-list {
					display: flex !important;
					flex-direction: row !important;
					gap: 10px !important;
					margin: 0 !important;
					padding: 0 !important;
					
					.language {
						width: 160px !important;
						height: 140px !important;
						border-radius: 12px !important;
						overflow: hidden !important;
						
						.wf-flag {
							width: 100% !important;
							height: 100% !important;
							background-size: cover !important;
							background-position: center !important;
						}
					}
				}
			}
		}
		
		/* Groups menu - remove extra padding that causes overscroll */
		.wf-groups-menu {
			padding-bottom: 1rem !important; /* Reduce from 6rem to minimal */
			margin-bottom: 0 !important;
		}
		
		/* 2-column grid for groups */
		.wf-groups-menu .wf-list {
			display: grid !important;
			grid-template-columns: repeat(2, 1fr) !important;
			gap: 8px !important;
			padding-bottom: 0 !important;
			margin-bottom: 0 !important;
		}
		
		/* Group items - Clean styling WITHOUT white overlay */
		.wf-groups-menu .wf-list-item {
			height: 220px !important;
			min-height: 240px !important;
			margin: 0 !important;
			border-radius: 16px !important;
			display: flex !important;
			align-items: center !important;
			justify-content: flex-start !important;
			overflow: hidden !important;
			
			/* Remove any pseudo-element overlays */
			&::before,
			&::after {
				display: none !important;
				content: none !important;
			}
			
			/* Override any internal flex/grid - ensure vertical centering */
			.wf-item-content,
			.wf-group {
				display: flex !important;
				flex-direction: row !important;
				align-items: center !important;
				justify-content: flex-start !important;
				width: 100% !important;
				height: 100% !important;
				gap: 20px !important;
				background: transparent !important;
				
				&::before,
				&::after {
					display: none !important;
					content: none !important;
				}
			}
			

			.wf-list-header {
				height: 2rem;
			}

			/* Icon - fixed size, comes first, vertically centered */
			.wf-group-icon,
			.group-icon-container,
			.wf-group-icon-container,
			[class*="icon-container"],
			.wf-icon {
				width: 90px !important;
				height: 90px !important;
				min-width: 90px !important;
				max-width: 90px !important;
				min-height: 90px !important;
				max-height: 90px !important;
				flex-shrink: 0 !important;
				order: -1 !important;
				display: flex !important;
				align-items: center !important;
				justify-content: center !important;
				background: transparent !important;
				
				img, svg {
					width: 100% !important;
					height: 100% !important;
					max-width: 60px !important;
					max-height: 60px !important;
					object-fit: contain !important;
				}
			}
			
			/* Text - normal weight, not uppercase, vertically centered */
			.wf-name,
			.wf-translate {
				font-size: 1.6rem !important;
				font-weight: 500 !important;
				text-transform: none !important;
				flex: 1 !important;
				line-height: 1.3 !important;
				display: flex !important;
				align-items: center !important;
				background: transparent !important;
			}
		}

		/* Fix for group POIs menu - override Vue scoped styles */
		.wf-group-pois-menu .wf-list-header,
		.wf-group-pois-menu .wf-list-header[data-v-e1e446f2],
		.wf-pois-menu .wf-list-header,
		div.wf-group-pois-menu div.wf-list-header,
		.wf-list-header {
			height: 5rem !important;
			font-size: 1.5rem !important;
			padding: 0.5rem 1rem !important;
		}

		/* POIs list items in group view */
		.wf-group-pois-menu .wf-list-item,
		.wf-pois-menu .wf-list-item {
			height: auto !important;
			min-height: 80px !important;
			padding: 1rem !important;
			font-size: 1rem !important;
		}
		
		/* Fix scrolling - minimal change */
.menus {
	width: 100% !important;
	min-width: 100% !important;
	max-width: 100% !important;
	height: 48% !important;
	max-height: 48% !important;
	flex: none !important;
	padding: 1.5rem !important;
	box-shadow: none !important;
	overflow: hidden !important;
}

.menus-bottom {
	display: flex !important;
	flex-direction: column !important;
	height: 100% !important;
	overflow: visible !important;
}

.tabs-container,
.col-tabs-container {
	flex: 1 !important;
	overflow: visible !important;
	height: calc(100% - 250px) !important;
	max-height: calc(100% - 250px) !important;
}

.wf-tabs,
.wf-component.wf-tabs {
	height: 100% !important;
	max-height: 100% !important;
	overflow: visible !important;
}

.wf-tabs-content {
	height: 100% !important;
	max-height: 100% !important;
	overflow: visible !important;
}

.wf-tab,
.wf-tab.wf-active {
	height: 100% !important;
	max-height: 100% !important;
	overflow-y: auto !important;
	overflow-x: hidden !important;
}

.wf-scrollable-area,
.wf-component.wf-scrollable,
.wf-component.wf-scrollable.sa-on-top {
	height: auto !important;
	max-height: 100% !important;
	overflow-y: auto !important;
	overflow-x: hidden !important;
	-webkit-overflow-scrolling: touch !important;
	overscroll-behavior: contain !important; /* Prevent overscrolling */
}

.wf-group-pois-menu,
.wf-groups-menu {
	height: auto !important;
	overflow: visible !important;
}

.wf-group-pois-menu .wf-list,
.wf-pois-menu .wf-list {
	height: auto !important;
	overflow: visible !important;
}
		
		/* Floor buttons in map area - BIGGER */
		.wf-component.wf-floors-menu {
			right: 1rem !important;
			top: 15% !important;
			transform: none !important;
			padding: 15px !important;
			border-radius: 20px !important;
			
			.wf-list {
				flex-direction: column !important;
				gap: 15px !important;
			}
			
			.wf-list-item {
				width: 210px !important;
				height: 210px !important;
				min-width: 140px !important;
				min-height: 140px !important;
				font-size: 2rem !important;
				border-radius: 18px !important;
			}
		}
		
	}
	@media (min-width: 3600px) and (orientation: landscape) {
	html {
		font-size: 38px !important;
	}

	/* Make menu sidebar wider */
	.menus {
		width: 1000px !important;
		min-width: 1000px !important;
		max-width: 1000px !important;
	}

	/* Position floor buttons to account for wider menu */
	.wf-component.wf-floors-menu {
		right: 1020px !important;
		border-radius: 20px !important;
		
		.wf-list {
			flex-direction: column !important;
			gap: 15px !important;
		}
		
		.wf-list-item {
			width: 140px !important;
			height: 140px !important;
			min-width: 140px !important;
			min-height: 140px !important;
			font-size: 2.5rem !important;
			border-radius: 18px !important;
		}
	}

	/* Search bar */
	.search-bar {
		height: 140px !important;
		border: none !important;
		margin-bottom: 0 !important;
		background-color: #e3e3e3 !important;
		border-radius: 16px 16px 0 0 !important;
		display: flex !important;
		align-items: center !important;
		
		.shortcuts-button {
			width: 130px !important;
			height: 120px !important;
			flex-shrink: 0 !important;
			border-radius: 16px !important;
			
			img {
				width: 50px !important;
				height: 50px !important;
			}
			
			.shortcuts-label {
				font-size: 0.6rem !important;
				margin-top: 4px !important;
			}
		}
		
		.tab-buttons {
			flex: 1 !important;
			height: 120px !important;
			
			.tab-button {
				font-size: 1.1rem !important;
				border-radius: 16px !important;
			}
		}
	}

	/* Groups menu items - bigger */
	.wf-groups-menu .wf-list-item {
		height: 140px !important;
		min-height: 140px !important;
		margin-bottom: 4px !important;
		border-radius: 12px !important;
		
		.wf-group .wf-name,
		.wf-name {
			font-size: 1.3rem !important;
		}
		
		.wf-group-icon {
			width: 50px !important;
			height: 50px !important;
			min-width:70px !important;
			min-height: 70px !important;
		}
	}

	/* Fix for group POIs menu - override Vue scoped styles */
	.wf-group-pois-menu .wf-list-header,
	.wf-group-pois-menu .wf-list-header[data-v-e1e446f2],
	.wf-pois-menu .wf-list-header,
	div.wf-group-pois-menu div.wf-list-header,
	.wf-list-header {
		height: 80px !important;
		font-size: 1.3rem !important;
		padding: 0.5rem 1rem !important;
	}

	/* POIs list items in group view */
	.wf-group-pois-menu .wf-list-item,
	.wf-pois-menu .wf-list-item {
		height: auto !important;
		min-height: 160px !important;
		padding: 1rem !important;
		font-size: 1.2rem !important;
	}

	/* POI Detail View - copied from portrait */
	.wf-poi-description {
		width: 90% !important;
		max-width: 100% !important;
		margin: 0 auto !important;
		padding: 1rem !important;
		font-size: 1.2rem !important;
		text-align: center !important;
		line-height: 1.4 !important;
	}

	.wf-poi-image {
		max-width: 15rem !important;
		min-height: 200px;
		margin: 0 auto 1rem auto !important;
	}

	.back-button {
		padding: 0.5rem !important;
		margin: 0.5rem !important;
		cursor: pointer !important;
		
		img {
			width: 100px !important;
			height: 100px !important;
		}
	}

	.wf-poi-name {
		font-size: 1.3rem !important;
		text-align: center !important;
		margin-bottom: 0.5rem !important;
	}
	
	.wf-show-path,
	.show-path-button {
		position: relative !important;
		z-index: 0 !important;
		width: 100% !important;
		max-width: 100% !important;
	}

	.wf-show-path button,
	.wf-show-path .show-path-button {
		font-size: 1.2rem !important;
		height: 80px !important;
		min-height: 80px !important;
		padding-left: 2rem !important;
		padding-right: 2rem !important;
		width: 100% !important;
		max-width: 100% !important;
		border-radius: 12px !important;
		gap: 0.5rem !important;
		
		label {
			font-size: 1.2rem !important;
			font-weight: 700 !important;
		}
		
		.path-icon {
			width: 32px !important;
			height: 32px !important;
		}
	}

	/* Back header (TAGASI) */
	.list-back-header {
		height: 5rem !important;
		font-size: 1.2rem !important;
		padding: 0 1rem !important;
		display: flex !important;
		align-items: center !important;
		gap: 0.5rem !important;
		
		.back-arrow-icon {
			width: 2rem !important;
			height: 2rem !important;
		}
	}

	/* POI portrait container */
	.poi-portrait {
		padding: 1rem !important;
		display: flex !important;
		flex-direction: column !important;
		align-items: center !important;
	}

	.scrollable {
		height: 100% !important;
		overflow-y: auto !important;
	}

	
}
	
	
</style>